import z, { literal, preprocess } from 'zod';

import { requiresActivationConstraintWithLimitsSchema } from '@occc/feat-constraints/schemas';

import { ProductPurchaseSchema } from './product-purchase.schema';

import { AwardCountSchema } from '../award-count.schema';
import {
  AwardExternalVariantSchema,
  AwardPointsVariantSchema,
  AwardVouchersVariantSchema,
} from '../award.schema';
import { BaseOfferConfigurationSchema } from '../base-offer.schema';
import { OfferType } from '../../types';

const ProductPurchaseOfferBaseSchema = BaseOfferConfigurationSchema.extend({
  offerType: literal(OfferType.ProductPurchase),
  productPurchase: preprocess((data) => data ?? {}, ProductPurchaseSchema),
  awardCount: AwardCountSchema,
  activation: requiresActivationConstraintWithLimitsSchema,
});

export const ProductPurchaseOfferSchema = z.discriminatedUnion('awardType', [
  ProductPurchaseOfferBaseSchema.merge(AwardPointsVariantSchema),
  ProductPurchaseOfferBaseSchema.merge(AwardVouchersVariantSchema),
  ProductPurchaseOfferBaseSchema.merge(AwardExternalVariantSchema),
]);
